import "./MailAddress.scss";

const MailAddress = () => {
  return (
    <div className="mail-address">
      <a href="mailto:pradier.corinne@gmail.com">pradier.corinne@gmail.com</a>
    </div>
  );
};

export default MailAddress;
